import { ComponentDefinitionBuilder } from 'nest/platform/models';
import { capabilities } from '../../capabilities';
import { CONNECTION_SETTINGS_MODAL_COMPONENT, NC_PLATFORM_NAME } from '../constants';
export const connectionSettingsModalComponentDef = ComponentDefinitionBuilder.builder(CONNECTION_SETTINGS_MODAL_COMPONENT).setPath('/connections-embed/:portalId/navigation-modal').setCapabilities([capabilities.HIDE_COMPONENT_CAP.getName()]).setPlatformName(NC_PLATFORM_NAME).setIframeProps({
  style: {
    width: 0,
    height: 0
  }
}).build();